import { render, staticRenderFns } from "./FileDrop.vue?vue&type=template&id=4334ed52&scoped=true&"
import script from "./FileDrop.vue?vue&type=script&lang=ts&"
export * from "./FileDrop.vue?vue&type=script&lang=ts&"
import style0 from "./FileDrop.vue?vue&type=style&index=0&id=4334ed52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4334ed52",
  null
  
)

export default component.exports